<script>
import { fandomBasicMixin } from 'src/modules/fandom_mixins_module.js';
import StripeHeader from "stripe-header";

export default {
  components: {
    StripeHeader
  },
  mixins: [fandomBasicMixin]
};
</script>

<template>
  <div 
    v-easyadmin="easyadminId" 
    v-if="isContentVisibleToUser()"
    :class="contentType"
    class="py-4 pb-5"
    :style="{'background-color': (content.background_color || 'inherit')}"
    list-keypoints-v3-component
  >
    <stripe-header :content="content" align="center"></stripe-header>
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-12 col-md-8">
          <table class="w-100" border="0">
            <tr v-for="(keypoint, index) in content.keypoints">
              <td>
                <div class="number pt-4 pr-4 pr-md-5 position-relative" :class="{'text-right': content.align_center}" v-if="keypoint.number">
                  {{keypoint.number}}
                  <div class="dot"></div>
                </div>
              </td>
              <td class="divider"></td>
              <td>
                <div class="h3 text-uppercase pl-4 pl-md-5" v-if="keypoint.title">
                  {{keypoint.title}}
                </div>
                <p v-html="keypoint.description" class="text-gray-500 pl-4 pl-md-5" v-if="keypoint.description"></p>
              </td>
            </tr>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
[list-keypoints-v3-component] {
  .divider {
    width: 2px;
    background-color: $gray-500;
  }

  td {
    border: none;
  }

  td:first-child {
    vertical-align: baseline;
  }

  td:last-child {
    padding-top: 2.75rem;
  }

  .dot {
    width: 20px;
    height: 20px;
    border-radius: 100%;
    border: 2px solid $gray-500;
    right: -12px;
    background-color: $white;
    position: absolute;
    top: 2.75rem;
  }


  .number {
    font-size: 2.75rem;
  }
}
</style>